import React, { useCallback, useRef, useEffect, useState } from 'react';
import { uuid } from 'uuidv4';
import { useConfiguration } from '../../hooks/Configuration';
import { usePrinter } from '../../hooks/PrinterHook';
import { useToast } from '../../hooks/Toast';
import api from '../../services/api';
import { decodeCracha } from '../DashboardPages/core/components/lineModules/Cracha';
import NumberPad from './modules/numberPad';

import { Container, Content, Background, AnimatedDiv2 } from './styles';
import QRCode from 'qrcode.react';
import StudentUpdate from './modules/studentUpdate';
import { defaultProjectHash } from '../../config';
import { useParams } from 'react-router-dom';
import { useLoading } from '../../hooks/LoadingHook';

interface AutoatendimentoPresencaData {
  email: string;
  password: string;
  name: string;
}

/* 
Rules
Can only print if the reference is different than yes 
have to add crm and crm uf if is Médico or Psicólogo 

*/

const AutoatendimentoPresenca: React.FC = () => {

  const [value, setValue] = useState('');
  const [country, setCountry] = useState('BR');
  const [status, setStatus] = useState('waiting');
  const [padPadNumberKey, setPadNumberKey] = useState(uuid());
  const [studentInfo, setStudentInfo] = useState<Record<string, any>>();
  const { addToast } = useToast();
  const { addPrint, printIt } = usePrinter();
  const { configuration } = useConfiguration();
  const { hash, projectHash = defaultProjectHash } = useParams<Record<string, any>>();
  const { addLoading, removeLoading } = useLoading();
  const reset = () => {
    setValue('');
    setCountry('BR');
    setStatus('ready');
    setPadNumberKey(uuid());
  }

  function formatCPF(cpf: string): string {
    const digits = cpf.replace(/\D/g, ''); // remove qualquer coisa que não seja número

    if (digits.length !== 11) return cpf; // retorna original se não tiver 11 dígitos

    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  const loadQRcode = async (contentHash) => {
    addLoading({ title: 'Validando', key: 'loading' })
    try {
      console.log('validando')
      const check = await api.get(`/check-preorder/${contentHash}`);
      console.log(check?.data?.status)
      if (check?.data?.status === 'continue') {
        setStatus('ready');
      }
      else if (check?.data?.status === 'not-found') {
        setStatus('not-found');
      }
      else if (check?.data?.status === 'used') {
        setStatus('used');
      }
      removeLoading('loading');
    }
    catch (err) {
      setStatus('error');
      removeLoading('loading');
    }

  }

  useEffect(() => {

    loadQRcode(hash)


  }, [hash])



  const printMyBadge = async (currentValue) => {
    addLoading({ title: 'Carregando', key: 'loading2' });
    try {
      const preorder = await api.post(`/apply-preorder/${hash}`, { document_number: formatCPF(currentValue) });
      if (preorder?.data?.status === 'not-found') {
        setStatus('not-found');
        removeLoading('loading2');
        return;
      }

      if (preorder?.data?.status === 'user-not-found') {
        setStatus('user-not-found');
        removeLoading('loading2');
        return;
      }

      if (preorder?.data?.status === 'used') {
        setStatus('used');
        removeLoading('loading2');
        return;
      }
      if (preorder?.data?.status === 'completed') {
        setStatus('confirmed');
        removeLoading('loading2');
        return;
      }


      setStatus('ready')
      removeLoading('loading2');



    }
    catch (err) {
      removeLoading('loading2');
      addToast({ title: err?.response?.data?.message || err?.response?.data?.error || 'Erro ao solicitar autoatendimento, dirija-se ao credenciamento.' })
    }

  }

  if (status === 'waiting') {
    return <Container style={{ flexDirection: 'column', gap: '20px' }}>
      <h2 style={{ fontSize: '28px' }}>Carregando...</h2>

    </Container>
  }

  if (status === 'not-found') {
    return <Container style={{ flexDirection: 'column', gap: '20px' }}>
      <h2 style={{ fontSize: '28px' }}>QRCode não identificado</h2>


    </Container>
  }

  if (status === 'user-not-found') {
    return <Container style={{ flexDirection: 'column', gap: '20px' }}>
      <h2 style={{ fontSize: '28px' }}>Participante não identificado</h2>

      <button className='defaultButton' onClick={() => setStatus('ready')}>Inserir outro CPF</button>
    </Container>
  }

  if (status === 'error') {
    return <Container style={{ flexDirection: 'column', gap: '20px' }}>
      <h2 style={{ fontSize: '28px' }}>Erro ao validar QRCode</h2>

    </Container>
  }


  if (status === 'used') {
    return <Container style={{ flexDirection: 'column', gap: '20px' }}>
      <h2 style={{ fontSize: '28px' }}>Este QRCode já foi utilizado</h2>


    </Container>
  }

  if (status === 'confirmed') {
    return <Container style={{ flexDirection: 'column', gap: '20px' }}>
      <h2 style={{ fontSize: '28px' }}>Presença confirmada com sucesso!</h2>
    </Container>
  }


  if (status === 'ready') {

    return <Container>
      <div>
        <h2 style={{ margin: '20px auto' }}>INSIRA SEU CPF</h2>


        {country === 'BR' ? <div className='number-display'>
          <aside>{value?.[0]}</aside>
          <aside>{value?.[1]}</aside>
          <aside>{value?.[2]}</aside>.
          <aside>{value?.[3]}</aside>
          <aside>{value?.[4]}</aside>
          <aside>{value?.[5]}</aside>.
          <aside>{value?.[6]}</aside>
          <aside>{value?.[7]}</aside>
          <aside>{value?.[8]}</aside>-
          <aside>{value?.[9]}</aside>
          <aside>{value?.[10]}</aside>


        </div> : <div className='number-display-estrangeiros'>
          <aside>{value}</aside>


        </div>}

      </div>

      <div style={{ width: '30%' }}>
        <NumberPad keyValue={padPadNumberKey} maximum={country === 'BR' ? 11 : 15} setCallback={(newValue => setValue(newValue))} />

        <button className='defaultButton' onClick={() => { printMyBadge(value) }}>Enviar</button>

        {country === 'BR' ? <button className='defaultButton' onClick={() => setCountry('AR')}>Sou estrangeiro</button> : <button className='defaultButton' onClick={() => setCountry('BR')}>Sou brasileiro</button>}

      </div>
    </Container>
  }

  return <></>;
};
export default AutoatendimentoPresenca;
